// RegistrationContent.js
import React, { useState } from "react";
import { Container, Tabs, Tab } from "@mui/material";
import TopTitleBanner from "../component/TopTitleBanner";
import "../css/dashboard.css";
import ClientsGroupAttendanceRegister from "../component/registrationcomponent/ClientsGroupAttendanceRegister";
import ClientRegister from "../component/registrationcomponent/ClientRegister";

export default function RegistrationContent() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div
      className="right-container"
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignContent: "flex-start",
        alignItems: "flex-start",
        alignSelf: "flex-start",
      }}
    >
      <TopTitleBanner title={"Registration"} />
      <Container
        style={{
          marginTop: "20px",
          marginLeft: 0,
          marginRight: 0,
          textAlign: "left",
          paddingLeft: "60px",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Clients Group Attendence Register" />
          <Tab label="Clients register" />
        </Tabs>
        <div style={{ marginTop: "20px" }}>
          {activeTab === 0 && <ClientsGroupAttendanceRegister />}
          {activeTab === 1 && <ClientRegister />}
        </div>
      </Container>
    </div>
  );
}
